import React, { useEffect } from 'react';
import { WifiOff } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNetworkStatus } from '../hooks/useNetworkStatus';
import { useSuccessToast } from '../store/successToastStore';
export function OfflineBanner() {
  const {
    isOnline,
    wasOffline
  } = useNetworkStatus();
  const {
    showToast
  } = useSuccessToast();
  useEffect(() => {
    if (wasOffline && isOnline) {
      showToast('Back online');
    }
  }, [wasOffline, isOnline, showToast]);
  return <AnimatePresence data-id="element-300" data-mp="2duhpzsuwhxcc">
      {!isOnline && <motion.div initial={{
      y: '-100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '-100%'
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed top-0 left-0 right-0 h-[44px] bg-text-primary z-[10000] flex items-center justify-center gap-2 px-4" data-id="element-301" data-mp="2dxdnjg2u6k09">
          <WifiOff size={16} className="text-white flex-shrink-0" data-id="element-302" data-mp="292t9rttzk88l" />
          <span className="text-white text-[13px] font-medium" data-id="element-303" data-mp="2929tehjzhrwo">
            You're offline — some features may be unavailable
          </span>
        </motion.div>}
    </AnimatePresence>;
}